import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import { createVNode, normalizeProps } from "inferno";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { Component } from 'inferno';
import Mobiledoc from 'mobiledoc-kit';

if (typeof requestAnimationFrame === 'undefined') {}

export var EMPTY_MOBILEDOC = {
  version: "0.3.0",
  markups: [],
  atoms: [],
  cards: [],
  sections: []
};
var defaultProps = {
  atoms: [],
  autofocus: true,
  cardProps: {},
  cards: [],
  placeholder: "",
  serializeVersion: "0.3.0",
  spellcheck: true
};

var Container = /*#__PURE__*/function (_Component) {
  _inherits(Container, _Component);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Container).apply(this, arguments));
    _this.state = {
      activeMarkupTags: [],
      activeSectionTags: []
    };
    _this.setActiveTags = _this.setActiveTags.bind(_assertThisInitialized(_this));
    return _this;
  }
  /*
  propTypes: {
    atoms: PropTypes.array,
    autofocus: PropTypes.bool,
    cards: PropTypes.array,
    didCreateEditor: PropTypes.func,
    html: PropTypes.string,
    mobiledoc: PropTypes.object,
    onChange: PropTypes.func,
    options: PropTypes.object,
    placeholder: PropTypes.string,
    serializeVersion: PropTypes.string,
    spellcheck: PropTypes.bool,
    willCreateEditor: PropTypes.func
  },
   childContextTypes: {
    editor: PropTypes.object,
    activeMarkupTags: PropTypes.array,
    activeSectionTags: PropTypes.array
  },
  */


  _createClass(Container, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        editor: this.editor,
        activeMarkupTags: this.state.activeMarkupTags,
        activeSectionTags: this.state.activeSectionTags
      };
    }
  }, {
    key: "_onAnimationFrame",
    value: function _onAnimationFrame() {
      var _this2 = this;

      this._animFrameTick = requestAnimationFrame(function () {
        return _this2._onAnimationFrame();
      });
      this.props.onAnimFrame(this.editor);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      if (typeof this.props.willCreateEditor === 'function') {
        this.props.willCreateEditor();
      }

      var mobiledoc = this.props.mobiledoc || EMPTY_MOBILEDOC;
      var _this$props = this.props,
          atoms = _this$props.atoms,
          autofocus = _this$props.autofocus,
          cardProps = _this$props.cardProps,
          cards = _this$props.cards,
          html = _this$props.html,
          placeholder = _this$props.placeholder,
          serializeVersion = _this$props.serializeVersion,
          spellcheck = _this$props.spellcheck;

      var editorOptions = _objectSpread({}, this.props.options, {
        atoms: atoms,
        autofocus: autofocus,
        cardOptions: {
          cardProps: cardProps
        },
        cards: cards,
        html: html,
        mobiledoc: mobiledoc,
        placeholder: placeholder,
        serializeVersion: serializeVersion,
        spellcheck: spellcheck
      });

      this.editor = new Mobiledoc.Editor(editorOptions);
      this.editor.inputModeDidChange(this.setActiveTags);
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          didCreateEditor = _this$props2.didCreateEditor,
          onCursorDidChange = _this$props2.onCursorDidChange,
          onAnimFrame = _this$props2.onAnimFrame;

      if (typeof onChange === 'function') {
        this.editor.postDidChange(function () {
          var mobiledoc = _this3.editor.serialize(_this3.props.serializeVersion);

          onChange(mobiledoc);
        });
      }

      if (typeof didCreateEditor === 'function') {
        didCreateEditor(this.editor);
      }

      if (typeof onCursorDidChange === 'function') {
        this.editor.cursorDidChange(function () {
          return onCursorDidChange(_this3.editor);
        });
      }

      if (typeof onAnimFrame === 'function') {
        // Do nothing if we are doing SSR
        if (typeof requestAnimationFrame !== 'undefined') {
          this._onAnimationFrame();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._animFrameTick && cancelAnimationFrame(this._checkCursorPosAnimFrame);
      this.editor.destroy();
    }
  }, {
    key: "setActiveTags",
    value: function setActiveTags() {
      this.setState({
        activeMarkupTags: this.editor.activeMarkups.map(function (m) {
          return m.tagName;
        }),
        // editor.activeSections are leaf sections.
        // Map parent section tag names (e.g. 'p', 'ul', 'ol') so that list buttons
        // are updated.
        activeSectionTags: this.editor.activeSections.map(function (s) {
          return s.isNested ? s.parent.tagName : s.tagName;
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */

      /* deconstruct out non-React props before passing to children */
      var _this$props3 = this.props,
          atoms = _this$props3.atoms,
          autofocus = _this$props3.autofocus,
          cardProps = _this$props3.cardProps,
          cards = _this$props3.cards,
          children = _this$props3.children,
          didCreateEditor = _this$props3.didCreateEditor,
          html = _this$props3.html,
          mobiledoc = _this$props3.mobiledoc,
          options = _this$props3.options,
          placeholder = _this$props3.placeholder,
          serializeVersion = _this$props3.serializeVersion,
          spellcheck = _this$props3.spellcheck,
          willCreateEditor = _this$props3.willCreateEditor,
          componentProps = _objectWithoutProperties(_this$props3, ["atoms", "autofocus", "cardProps", "cards", "children", "didCreateEditor", "html", "mobiledoc", "options", "placeholder", "serializeVersion", "spellcheck", "willCreateEditor"]);
      /* eslint-enable no-unused-vars */


      return normalizeProps(createVNode(1, "div", null, children, 0, _objectSpread({}, componentProps)));
    }
  }]);

  return Container;
}(Component);

Container.defaultProps = defaultProps;
export default Container;